export const RadioListRightContentName = 'radioListRightContentComponent';
